import { render, staticRenderFns } from "./TagSelectItem.vue?vue&type=template&id=3c445272&"
import script from "./TagSelectItem.vue?vue&type=script&lang=js&"
export * from "./TagSelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c445272')) {
      api.createRecord('3c445272', component.options)
    } else {
      api.reload('3c445272', component.options)
    }
    module.hot.accept("./TagSelectItem.vue?vue&type=template&id=3c445272&", function () {
      api.rerender('3c445272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/TagSelectItem.vue"
export default component.exports